/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/lib/api";
import type {
  GetTournamentsDraftCaptainBudgetDefaultQueryResponse,
  GetTournamentsDraftCaptainBudgetDefault500,
} from "../types/GetTournamentsDraftCaptainBudgetDefault.ts";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "@/shared/lib/api";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const getTournamentsDraftCaptainBudgetDefaultQueryKey = () =>
  [{ url: "/tournaments/draft/captain-budget/default" }] as const;

export type GetTournamentsDraftCaptainBudgetDefaultQueryKey = ReturnType<
  typeof getTournamentsDraftCaptainBudgetDefaultQueryKey
>;

/**
 * {@link /tournaments/draft/captain-budget/default}
 */
export async function getTournamentsDraftCaptainBudgetDefault(
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetTournamentsDraftCaptainBudgetDefaultQueryResponse,
    ResponseErrorConfig<GetTournamentsDraftCaptainBudgetDefault500>,
    unknown
  >({
    method: "GET",
    url: `/tournaments/draft/captain-budget/default`,
    ...requestConfig,
  });
  return res;
}

export function getTournamentsDraftCaptainBudgetDefaultQueryOptions(
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey = getTournamentsDraftCaptainBudgetDefaultQueryKey();
  return queryOptions<
    ResponseConfig<GetTournamentsDraftCaptainBudgetDefaultQueryResponse>,
    ResponseErrorConfig<GetTournamentsDraftCaptainBudgetDefault500>,
    ResponseConfig<GetTournamentsDraftCaptainBudgetDefaultQueryResponse>,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return getTournamentsDraftCaptainBudgetDefault({
        ...config,
        signal: config.signal ?? signal,
      });
    },
  });
}

/**
 * {@link /tournaments/draft/captain-budget/default}
 */
export function useGetTournamentsDraftCaptainBudgetDefault<
  TData = ResponseConfig<GetTournamentsDraftCaptainBudgetDefaultQueryResponse>,
  TQueryData =
    ResponseConfig<GetTournamentsDraftCaptainBudgetDefaultQueryResponse>,
  TQueryKey extends QueryKey = GetTournamentsDraftCaptainBudgetDefaultQueryKey,
>(
  options: {
    query?: Partial<
      QueryObserverOptions<
        ResponseConfig<GetTournamentsDraftCaptainBudgetDefaultQueryResponse>,
        ResponseErrorConfig<GetTournamentsDraftCaptainBudgetDefault500>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ??
    getTournamentsDraftCaptainBudgetDefaultQueryKey();

  const query = useQuery(
    {
      ...getTournamentsDraftCaptainBudgetDefaultQueryOptions(config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<GetTournamentsDraftCaptainBudgetDefault500>
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
